import Header from '../Header/Header';
import Highlights from '../Highlights/Highlights';
import Testimonials from '../Testimonials/Testimonials';
import About from '../About/About';

const Main = () => {
    return (
        <main>
            <Header />
            <Highlights />
            <Testimonials />
            <About />
        </main>
    );
}

export default Main;